import * as Tone from 'tone';

// Piano: synthesized for now (no sample loading). Triangle wave + percussive
// envelope approximates piano character. Swap-in via Tone.Sampler later.

export default {
    id: 'piano',
    name: 'Piano',
    register(ctx) {
        const channel = ctx.mixer.addChannel({ id: 'piano', name: 'Piano', color: '#569cd6' });
        channel.setVolume(-8);

        const piano = new Tone.PolySynth(Tone.Synth, {
            oscillator: { type: 'triangle' },
            envelope: { attack: 0.005, decay: 0.5, sustain: 0.05, release: 1.2 },
        });
        piano.connect(channel.input);

        ctx.instruments.register({
            id: 'piano',
            name: 'Piano',
            kind: 'pitched',
            channelId: 'piano',
            play(note, time, duration = '8n', velocity = 0.85) {
                try { piano.triggerAttackRelease(note, duration, time, velocity); } catch (_) {}
            },
        });

        ctx.lanes.add({
            id: 'piano',
            name: 'Piano',
            instrumentId: 'piano',
            kind: 'pitched',
            color: '#569cd6',
            defaultOctave: 3,
        });
    },
};
